import { DebugLogger } from '~/other/DebugLogger';
import { useMemo } from "react";

export default function useDebugLogger(name) {
    const debugLogger = useMemo(() => DebugLogger.getLogger(name), [name]);
    return debugLogger;
}